import i18next from 'i18next';
import * as yup from 'yup';

import { type PaymentFilter } from '../../models/Payment';

export interface PaymentOption {
  id: string;
  name: string;
}

export interface PaymentFilterForm {
  tin?: string;
  taxCollector?: PaymentOption;
  jurisdiction?: PaymentOption;
  status?: PaymentOption;

  dateFrom?: Date;
  dateTo?: Date;

  amountFrom?: number;
  amountTo?: number;
}

export const DEFAULT_RELATIONS = [
  'Currency',
  'PaymentMethod',
  'TaxReturn',
  'TaxReturn.Taxpayer',
  'ReconciliationOfPayments.PaymentsReceived.PaymentReceived'
];

export const PAYMENT_STATES = ['pending', 'rejected', 'reconciled'];

export const paymentSearchValidation = yup.object().shape({
  dateFrom: yup.date().nullable(),

  dateTo: yup
    .date()
    .nullable()
    .when('dateFrom', {
      is: (dateFrom: Date | null | undefined) => !!dateFrom,

      then: (schema) =>
        schema.min(
          yup.ref('dateFrom'),
          i18next.t('management-report.validations.dateToGreaterThan')
        )
    }),

  amountFrom: yup.number().nullable(),

  amountTo: yup
    .number()
    .nullable()
    .when('amountFrom', {
      is: (amountFrom: number | null | undefined) =>
        amountFrom !== null && amountFrom !== undefined,

      then: (schema) =>
        schema.min(
          yup.ref('amountFrom'),
          i18next.t('taxpayer-payments.validations.amountToGreaterThan')
        )
    })
});

export const mapPaymentFormToSearch = (values: PaymentFilterForm): PaymentFilter => ({
  tin: values.tin,
  status: values.status?.id,
  dateFrom: values.dateFrom,
  dateTo: values.dateTo,
  amountFrom: values.amountFrom,
  amountTo: values.amountTo
});
